export const isDisabled = ({ isForceDisabled, isOneSize, isNoSize }) =>
  isForceDisabled || isOneSize || isNoSize;
